export interface Country {
  code: string
  phoneCode: string
  currency: string
}

export const countries: Country[] = [
  { code: "AD", phoneCode: "+376", currency: "EUR" },
  { code: "AE", phoneCode: "+971", currency: "AED" },
  { code: "AF", phoneCode: "+93", currency: "AFN" },
  { code: "AG", phoneCode: "+1", currency: "XCD" },
  { code: "AI", phoneCode: "+1", currency: "XCD" },
  { code: "AL", phoneCode: "+355", currency: "ALL" },
  { code: "AM", phoneCode: "+374", currency: "AMD" },
  { code: "AO", phoneCode: "+244", currency: "AOA" },
  { code: "AQ", phoneCode: "+672", currency: "USD" },
  { code: "AR", phoneCode: "+54", currency: "ARS" },
  { code: "AT", phoneCode: "+43", currency: "EUR" },
  { code: "AU", phoneCode: "+61", currency: "AUD" },
  { code: "AW", phoneCode: "+297", currency: "AWG" },
  { code: "AX", phoneCode: "+358", currency: "EUR" },
  { code: "AZ", phoneCode: "+994", currency: "AZN" },
  { code: "BA", phoneCode: "+387", currency: "BAM" },
  { code: "BB", phoneCode: "+1", currency: "BBD" },
  { code: "BD", phoneCode: "+880", currency: "BDT" },
  { code: "BE", phoneCode: "+32", currency: "EUR" },
  { code: "BF", phoneCode: "+226", currency: "XOF" },
  { code: "BG", phoneCode: "+359", currency: "BGN" },
  { code: "BH", phoneCode: "+973", currency: "BHD" },
  { code: "BI", phoneCode: "+257", currency: "BIF" },
  { code: "BJ", phoneCode: "+229", currency: "XOF" },
  { code: "BN", phoneCode: "+673", currency: "BND" },
  { code: "BO", phoneCode: "+591", currency: "BOB" },
  { code: "BR", phoneCode: "+55", currency: "BRL" },
  { code: "BS", phoneCode: "+1", currency: "BSD" },
  { code: "BT", phoneCode: "+975", currency: "BTN" },
  { code: "BV", phoneCode: "+47", currency: "NOK" },
  { code: "BW", phoneCode: "+267", currency: "BWP" },
  { code: "BY", phoneCode: "+375", currency: "BYR" },
  { code: "BZ", phoneCode: "+501", currency: "BZD" },
  { code: "CA", phoneCode: "+1", currency: "CAD" },
  { code: "CC", phoneCode: "+61", currency: "AUD" },
  { code: "CD", phoneCode: "+243", currency: "CDF" },
  { code: "CF", phoneCode: "+236", currency: "XAF" },
  { code: "CG", phoneCode: "+242", currency: "XAF" },
  { code: "CH", phoneCode: "+41", currency: "CHF" },
  { code: "CI", phoneCode: "+225", currency: "XOF" },
  { code: "CL", phoneCode: "+56", currency: "CLP" },
  { code: "CM", phoneCode: "+237", currency: "XAF" },
  { code: "CN", phoneCode: "+86", currency: "CNY" },
  { code: "CO", phoneCode: "+57", currency: "COP" },
  { code: "CR", phoneCode: "+506", currency: "CRC" },
  { code: "CU", phoneCode: "+53", currency: "CUP" },
  { code: "CV", phoneCode: "+238", currency: "CVE" },
  { code: "CY", phoneCode: "+357", currency: "EUR" },
  { code: "CZ", phoneCode: "+420", currency: "CZK" },
  { code: "DE", phoneCode: "+49", currency: "EUR" },
  { code: "DJ", phoneCode: "+253", currency: "DJF" },
  { code: "DK", phoneCode: "+45", currency: "DKK" },
  { code: "DM", phoneCode: "+1", currency: "XCD" },
  { code: "DO", phoneCode: "+1", currency: "DOP" },
  { code: "DZ", phoneCode: "+213", currency: "DZD" },
  { code: "EC", phoneCode: "+593", currency: "USD" },
  { code: "EE", phoneCode: "+372", currency: "EUR" },
  { code: "EG", phoneCode: "+20", currency: "EGP" },
  { code: "EH", phoneCode: "+212", currency: "MAD" },
  { code: "ER", phoneCode: "+291", currency: "ERN" },
  { code: "ES", phoneCode: "+34", currency: "EUR" },
  { code: "ET", phoneCode: "+251", currency: "ETB" },
  { code: "FI", phoneCode: "+358", currency: "EUR" },
  { code: "FJ", phoneCode: "+679", currency: "FJD" },
  { code: "FM", phoneCode: "+691", currency: "USD" },
  { code: "FO", phoneCode: "+298", currency: "DKK" },
  { code: "FR", phoneCode: "+33", currency: "EUR" },
  { code: "GA", phoneCode: "+241", currency: "XAF" },
  { code: "GB", phoneCode: "+44", currency: "GBP" },
  { code: "GD", phoneCode: "+1", currency: "XCD" },
  { code: "GE", phoneCode: "+995", currency: "GEL" },
  { code: "GG", phoneCode: "+44", currency: "GGP" },
  { code: "GH", phoneCode: "+233", currency: "GHS" },
  { code: "GI", phoneCode: "+350", currency: "GIP" },
  { code: "GL", phoneCode: "+299", currency: "DKK" },
  { code: "GM", phoneCode: "+220", currency: "GMD" },
  { code: "GN", phoneCode: "+224", currency: "GNF" },
  { code: "GQ", phoneCode: "+240", currency: "XAF" },
  { code: "GR", phoneCode: "+30", currency: "EUR" },
  { code: "GT", phoneCode: "+502", currency: "GTQ" },
  { code: "GW", phoneCode: "+245", currency: "XOF" },
  { code: "GY", phoneCode: "+595", currency: "GYD" },
  { code: "HK", phoneCode: "+852", currency: "HKD" },
  { code: "HN", phoneCode: "+504", currency: "HNL" },
  { code: "HR", phoneCode: "+385", currency: "HRK" },
  { code: "HT", phoneCode: "+509", currency: "HTG" },
  { code: "HU", phoneCode: "+36", currency: "HUF" },
  { code: "ID", phoneCode: "+62", currency: "IDR" },
  { code: "IE", phoneCode: "+353", currency: "EUR" },
  { code: "IL", phoneCode: "+972", currency: "ILS" },
  { code: "IM", phoneCode: "+44", currency: "GBP" },
  { code: "IN", phoneCode: "+91", currency: "INR" },
  { code: "IQ", phoneCode: "+964", currency: "IQD" },
  { code: "IR", phoneCode: "+98", currency: "IRR" },
  { code: "IS", phoneCode: "+354", currency: "ISK" },
  { code: "IT", phoneCode: "+39", currency: "EUR" },
  { code: "JE", phoneCode: "+44", currency: "JEP" },
  { code: "JM", phoneCode: "+1", currency: "JMD" },
  { code: "JO", phoneCode: "+962", currency: "JOD" },
  { code: "JP", phoneCode: "+81", currency: "JPY" },
  { code: "KE", phoneCode: "+254", currency: "KES" },
  { code: "KG", phoneCode: "+996", currency: "KGS" },
  { code: "KH", phoneCode: "+855", currency: "KHR" },
  { code: "KI", phoneCode: "+686", currency: "AUD" },
  { code: "KM", phoneCode: "+269", currency: "KMF" },
  { code: "KN", phoneCode: "+1", currency: "XCD" },
  { code: "KP", phoneCode: "+850", currency: "KPW" },
  { code: "KR", phoneCode: "+82", currency: "KRW" },
  { code: "KW", phoneCode: "+965", currency: "KWD" },
  { code: "KZ", phoneCode: "+7", currency: "KZT" },
  { code: "LA", phoneCode: "+856", currency: "LAK" },
  { code: "LB", phoneCode: "+961", currency: "LBP" },
  { code: "LC", phoneCode: "+1", currency: "XCD" },
  { code: "LI", phoneCode: "+423", currency: "CHF" },
  { code: "LK", phoneCode: "+94", currency: "LKR" },
  { code: "LR", phoneCode: "+231", currency: "LRD" },
  { code: "LS", phoneCode: "+266", currency: "LSL" },
  { code: "LT", phoneCode: "+370", currency: "LTL" },
  { code: "LU", phoneCode: "+352", currency: "EUR" },
  { code: "LV", phoneCode: "+371", currency: "LVL" },
  { code: "LY", phoneCode: "+218", currency: "LYD" },
  { code: "MA", phoneCode: "+212", currency: "MAD" },
  { code: "MC", phoneCode: "+377", currency: "EUR" },
  { code: "MD", phoneCode: "+373", currency: "MDL" },
  { code: "ME", phoneCode: "+382", currency: "EUR" },
  { code: "MG", phoneCode: "+261", currency: "MGA" },
  { code: "MH", phoneCode: "+692", currency: "USD" },
  { code: "MK", phoneCode: "+389", currency: "MKD" },
  { code: "ML", phoneCode: "+223", currency: "XOF" },
  { code: "MM", phoneCode: "+95", currency: "MMK" },
  { code: "MN", phoneCode: "+976", currency: "MNT" },
  { code: "MR", phoneCode: "+222", currency: "MRO" },
  { code: "MT", phoneCode: "+356", currency: "EUR" },
  { code: "MU", phoneCode: "+230", currency: "MUR" },
  { code: "MV", phoneCode: "+960", currency: "MVR" },
  { code: "MW", phoneCode: "+265", currency: "MWK" },
  { code: "MX", phoneCode: "+52", currency: "MXN" },
  { code: "MY", phoneCode: "+60", currency: "MYR" },
  { code: "MZ", phoneCode: "+258", currency: "MZN" },
  { code: "NA", phoneCode: "+264", currency: "NAD" },
  { code: "NC", phoneCode: "+687", currency: "XPF" },
  { code: "NE", phoneCode: "+227", currency: "XOF" },
  { code: "NG", phoneCode: "+234", currency: "NGN" },
  { code: "NI", phoneCode: "+505", currency: "NIO" },
  { code: "NL", phoneCode: "+31", currency: "EUR" },
  { code: "NO", phoneCode: "+47", currency: "NOK" },
  { code: "NP", phoneCode: "+977", currency: "NPR" },
  { code: "NR", phoneCode: "+674", currency: "AUD" },
  { code: "NZ", phoneCode: "+64", currency: "NZD" },
  { code: "OM", phoneCode: "+968", currency: "OMR" },
  { code: "PA", phoneCode: "+507", currency: "PAB" },
  { code: "PE", phoneCode: "+51", currency: "PEN" },
  { code: "PG", phoneCode: "+675", currency: "PGK" },
  { code: "PH", phoneCode: "+63", currency: "PHP" },
  { code: "PK", phoneCode: "+92", currency: "PKR" },
  { code: "PL", phoneCode: "+48", currency: "PLN" },
  { code: "PR", phoneCode: "+1", currency: "USD" },
  { code: "PS", phoneCode: "+970", currency: "ILS" },
  { code: "PT", phoneCode: "+351", currency: "EUR" },
  { code: "PW", phoneCode: "+680", currency: "USD" },
  { code: "PY", phoneCode: "+595", currency: "PYG" },
  { code: "QA", phoneCode: "+974", currency: "QAR" },
  { code: "RO", phoneCode: "+40", currency: "RON" },
  { code: "RS", phoneCode: "+381", currency: "RSD" },
  { code: "RU", phoneCode: "+7", currency: "RUB" },
  { code: "RW", phoneCode: "+250", currency: "RWF" },
  { code: "SA", phoneCode: "+966", currency: "SAR" },
  { code: "SB", phoneCode: "+677", currency: "SBD" },
  { code: "SC", phoneCode: "+248", currency: "SCR" },
  { code: "SD", phoneCode: "+249", currency: "SDG" },
  { code: "SE", phoneCode: "+46", currency: "SEK" },
  { code: "SG", phoneCode: "+65", currency: "SGD" },
  { code: "SI", phoneCode: "+386", currency: "EUR" },
  { code: "SK", phoneCode: "+421", currency: "EUR" },
  { code: "SL", phoneCode: "+232", currency: "SLL" },
  { code: "SM", phoneCode: "+378", currency: "EUR" },
  { code: "SN", phoneCode: "+221", currency: "XOF" },
  { code: "SO", phoneCode: "+252", currency: "SOS" },
  { code: "SR", phoneCode: "+597", currency: "SRD" },
  { code: "SS", phoneCode: "+211", currency: "SSP" },
  { code: "ST", phoneCode: "+239", currency: "STD" },
  { code: "SV", phoneCode: "+503", currency: "SVC" },
  { code: "SY", phoneCode: "+963", currency: "SYP" },
  { code: "SZ", phoneCode: "+268", currency: "SZL" },
  { code: "TD", phoneCode: "+235", currency: "XAF" },
  { code: "TG", phoneCode: "+228", currency: "XOF" },
  { code: "TH", phoneCode: "+66", currency: "THB" },
  { code: "TJ", phoneCode: "+992", currency: "TJS" },
  { code: "TL", phoneCode: "+670", currency: "USD" },
  { code: "TM", phoneCode: "+993", currency: "TMT" },
  { code: "TN", phoneCode: "+216", currency: "TND" },
  { code: "TO", phoneCode: "+676", currency: "TOP" },
  { code: "TR", phoneCode: "+90", currency: "TRY" },
  { code: "TT", phoneCode: "+1", currency: "TTD" },
  { code: "TV", phoneCode: "+688", currency: "AUD" },
  { code: "TW", phoneCode: "+886", currency: "TWD" },
  { code: "TZ", phoneCode: "+255", currency: "TZS" },
  { code: "UA", phoneCode: "+380", currency: "UAH" },
  { code: "UG", phoneCode: "+256", currency: "UGX" },
  { code: "US", phoneCode: "+1", currency: "USD" },
  { code: "UY", phoneCode: "+598", currency: "UYU" },
  { code: "UZ", phoneCode: "+998", currency: "UZS" },
  { code: "VA", phoneCode: "+379", currency: "EUR" },
  { code: "VC", phoneCode: "+1", currency: "XCD" },
  { code: "VE", phoneCode: "+58", currency: "VEF" },
  { code: "VG", phoneCode: "+1", currency: "USD" },
  { code: "VN", phoneCode: "+84", currency: "VND" },
  { code: "VU", phoneCode: "+678", currency: "VUV" },
  { code: "WS", phoneCode: "+685", currency: "WST" },
  { code: "XK", phoneCode: "+383", currency: "EUR" },
  { code: "YE", phoneCode: "+967", currency: "YER" },
  { code: "ZA", phoneCode: "+27", currency: "ZAR" },
  { code: "ZM", phoneCode: "+260", currency: "ZMW" },
  { code: "ZW", phoneCode: "+263", currency: "USD" }
]
